/**
 * 車両表示順 (truck display order) の比較規則を集約する utility。
 *
 * API (app/controllers/api/v3/plannings/trucks_controller.rb) と一致させる:
 *   1. displayOrder が設定されている車両 (= TruckDisplayOrderVersion 経由で固定された車両) を先に出す
 *   2. bucket 内では displayOrder ?? sortOrder ?? MAX 昇順
 *   3. 同値の場合は id 昇順 (安定化用)
 *
 * Frontend で displayOrder ?? sortOrder だけで比較していると、
 *   - 履歴に含まれない新規車両の sortOrder が小さい → 履歴あり車両より前に並ぶ
 * という API との乖離が出るため、必ずこの util を使うこと。
 */

// app/controllers/api/v3/plannings/trucks_controller.rb の `2**16` と揃える。
// MAX_SAFE_INTEGER を使うと sortOrder > 65536 の車両が来た場合に API と順序が逆転するため、
// この値を必ず使うこと。
const FALLBACK_ORDER = 2 ** 16;

type TruckOrderKeyInput = {
  id: number;
  displayOrder?: number | null;
  sortOrder?: number | null;
};

export const truckDisplayOrderSortKey = (
  truck: TruckOrderKeyInput,
): [number, number, number] => {
  const hasDisplayOrder = truck.displayOrder != null;
  const value = truck.displayOrder ?? truck.sortOrder ?? FALLBACK_ORDER;
  return [hasDisplayOrder ? 0 : 1, value, truck.id];
};

export const compareTrucksByDisplayOrder = (
  a: TruckOrderKeyInput,
  b: TruckOrderKeyInput,
): number => {
  const ka = truckDisplayOrderSortKey(a);
  const kb = truckDisplayOrderSortKey(b);
  for (let i = 0; i < ka.length; i += 1) {
    if (ka[i] !== kb[i]) return ka[i] - kb[i];
  }
  return 0;
};
